import React, { useEffect, useState } from 'react';
import { Breadcrumbs, ToastMessage } from '@cokitchen/cokitchen-components';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeaderText from 'components/base/page-header-text';
import { apiService } from 'services/base.service';
import { ROUTE_KEYS } from 'utils/constants';
import { AddonsType, BaseAddonCategoryType } from 'utils/types';
import SingleBottomNav from 'components/base/single-bottom-nav';
import Select from 'components/base/select';
import { getBaseAddonCategory } from 'pages/base-items/util';

type formData = {
  id: string;
  meal_addon_category_id: string;
  base_addon_category_id: string;
};
export type multiselectOptionsType = {
  value: string;
  text: string;
};

const UpdateAddonCategory = () => {
  const { id, addon_id, title } = useParams();
  const [baseAddonCategory, setBaseAddonCategory] = useState([] as BaseAddonCategoryType[]);

  const [formData, setFormData] = useState({
    id: addon_id
  } as formData);
  const [loading, setLoading] = useState(false);
  const [addon, setAddon] = useState({} as AddonsType);

  const fetchAddon = async () => {
    try {
      const res = await apiService.get(`marketing/meal/meal-addons-categories/${id}`, {
        isInternal: true
      });
      const { data } = res.data;
      setAddon(data[0]);
      setFormData(data[0]);
    } catch (err: any) {
      toast(<ToastMessage type='error' message='Error fetching addon' />);
    }
  };
  useEffect(() => {
    if (id) fetchAddon();
  }, [id]);

  const breadcrumbs = [
    {
      name: addon.meal?.brand?.name ? `View ${addon.meal?.brand?.name}` : '...',
      path: `${ROUTE_KEYS.MEALS}?brand_id=${addon.meal?.brand?.id}`
    },
    {
      name: addon.meal?.meal_category?.name ?? '...',
      path: `${ROUTE_KEYS.MEALS}/${addon?.meal_category_id}`
    },
    {
      name: 'Addon categories',
      path: `${ROUTE_KEYS.MEALS}/${id}/addon-categories`
    },
    {
      name: 'Edit addon category',
      path: ''
    }
  ];

  const fetchData = async () => {
    const response: any = await apiService.get(`marketing/addon-category/${addon_id}`, {
      isInternal: true
    });
    const res: any = response.data.data;
    delete res.meal_category_selection_type;

    // setFormData({
    //   ...formData,
    //   id: res.id
    // });
  };

  const updateAddonCategory = async () => {
    setLoading(true);
    const payload: any = {
      ...formData
    };
    //delete payload.id;
    Object.keys(payload).forEach((k) => !payload[k] && payload[k] === '' && delete payload[k]);
    try {
      await apiService.put('marketing/meal-addon-category', {
        data: payload
      });
      toast(<ToastMessage type='success' message='Addon Category updated' />);
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [title]);

  const fetchBaseAddonCategories = async () => {
    const categories = await getBaseAddonCategory();
    setBaseAddonCategory(categories);
  };
  useEffect(() => {
    fetchBaseAddonCategories();
  }, []);

  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />

      <PageHeaderText title={`Edit ${title}`} description='Update add-on settings' />

      <div className='pt-3'>
        <div>
          <p className='text-xs'>Base addon category</p>
          <Select
            small
            hasSearch
            //loading={loading}
            value={formData.base_addon_category_id}
            options={baseAddonCategory?.map((item) => {
              return { value: item.id, text: item.name };
            })}
            placeholder='Select base addon category'
            onChange={(v) => setFormData({ ...formData, base_addon_category_id: v })}
          />
        </div>
        <SingleBottomNav
          btnDisabled={!formData.base_addon_category_id}
          onConfirm={updateAddonCategory}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default UpdateAddonCategory;
